var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioUncheckedCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.503906,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white",
    stroke: "#A1A1A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0001 10.7838L3.2201 8.0038L2.27344 8.9438L6.0001 12.6705L14.0001 4.67047L13.0601 3.73047L6.0001 10.7838Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioUncheckedCircleIcon);
export default __webpack_public_path__ + "static/media/radio_unchecked_circle_icon.568416ef.svg";
export { ForwardRef as ReactComponent };